 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // console.log("MAP Icon ", props)
        // props.context.componentParent.onCloseUploadDiv(e);
        // props.context.componentParent.onCloseRouteDiv(e);
        props.context.onShowNightDrivingData(props);
    };

    return (
            <a onClick={handleRouteClick}  title="Night Driving"><i className="icofont icofont-full-night f20"></i> </a>
        
    );
};

export default ConsignmentActions;
